import styled, { keyframes } from 'styled-components';
import { colors } from '../../styles/colors';
import { spacing } from '../../styles/spacing';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoaderSpinner = styled.div`
  border: 4px solid ${colors.background.secondary};
  border-top: 4px solid ${colors.primary.DEFAULT};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  animation: ${spin} 1s linear infinite;
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${spacing[8]};
  gap: ${spacing[4]};
`;

const LoaderText = styled.p`
  color: ${colors.text.secondary};
`;

const Loader: React.FC<{ text?: string }> = ({ text }) => (
  <LoaderContainer>
    <LoaderSpinner />
    {text && <LoaderText>{text}</LoaderText>}
  </LoaderContainer>
);

export default Loader;
